import "vant/es/icon/style";
import _Icon from "vant/es/icon";

var _components;

import './index-sfc.css';

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "nav-bar_content",
    class: {
      'nav-bar_fixed': _vm.fixed
    }
  }, [_c('div', {
    staticClass: "nav-bar_back",
    on: {
      "click": _vm.onBack
    }
  }, [_vm.close ? _c('van-icon', {
    attrs: {
      "name": "cross"
    }
  }) : _c('van-icon', {
    attrs: {
      "name": "arrow-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-bar_title single-ellipsis"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "nav-bar_block"
  })]);
};

var __vue_staticRenderFns__ = [];
export default {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'lt-nav-bar',
  components: (_components = {}, _components[_Icon.name] = _Icon, _components),
  props: {
    close: {
      type: Boolean,
      default: false
    },
    title: String,
    fixed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onBack: function onBack() {
      this.$emit('back');
    }
  }
};